import { api, loadScript } from "utils/util";
import { Dispatch, SetStateAction, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useMutation, useQueryClient } from "react-query";
import { Outlet } from "react-router-dom";
import ChannelTalk from "./ChannelTalk";
import { setCookie } from "../utils/util";
import { UserInfoQueryKey, useUserInfo } from "api/mypage/hooks";
import { toast } from "react-toastify";
import StyledButton from "@/submodules/integration-design-system/systems/moreden/components/styled-button/StyledButton";
import PageWrapper from "./PageWrapper";

const CheckCI = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { pathname } = useLocation();
  const isChicruiting = pathname.includes("chicruiting");
  const [loading, setLoading] = useState(false);
  const [mobileVerifiedMeta, setMobileVerifiedMeta] = useState(null);

  const updateCI = useMutation(
    (data: {
      phone: string;
      birthday: string;
      genderCd: string;
      ci: string;
      di: string;
      name: string;
    }) => api.post("/user/modifyPhone", data),
  );

  const getCheckCICookie = () => {
    const cookie = document.cookie;
    if (cookie.indexOf("checkCI=pass") < 0) {
      return true;
    } else return false;
  };

  const { data: myInfo } = useUserInfo();

  const fetchUserData = async (impUid: string) => {
    const data = {
      impUid,
    };
    try {
      const response = await api.post("/user/phoneCertification", data);
      return response.data;
    } catch (error) {
      console.error("Error fetching user data:", error);
      throw error;
    }
  };

  const performMobileVerification = async () => {
    await Promise.all([
      loadScript("pass-jquery", "https://code.jquery.com/jquery-1.12.4.min.js"),
      loadScript("pass-iamport", "https://cdn.iamport.kr/js/iamport.payment-1.2.0.js"),
    ]);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { IMP } = window as any;
    IMP.init("imp60774027");

    return new Promise((resolve, reject) => {
      IMP.certification(
        {
          min_age: 17,
        },
        (res: { success: boolean; imp_uid: string }) => {
          if (res.success) {
            resolve(res);
          } else {
            reject(new Error("Mobile verification failed"));
          }
        },
      );
    });
  };

  const mobileVerifyAndFetchUserData = async (setLoading: Dispatch<SetStateAction<boolean>>) => {
    try {
      setLoading(true);
      const res = (await performMobileVerification()) as { success: boolean; imp_uid: string };

      if (res.success) {
        const userData = await fetchUserData(res.imp_uid);
        setMobileVerifiedMeta(userData);
        updateCI.mutate(
          {
            phone: userData.phone,
            birthday: userData.birthday,
            genderCd: userData.gender === "male" ? "M" : "F",
            ci: userData.unique_key,
            di: userData.unique_in_site,
            name: userData.name,
          },
          {
            onSuccess: () => queryClient.invalidateQueries(UserInfoQueryKey),
            onError: () => {
              toast.error(
                "본인 인증에 실패했습니다. 추후 계정 사용이 중단될 수 있으니 고객센터로 문의해 주세요.",
              );
              setCookie("checkCI", "pass", 24);
            },
          },
        );
      }
    } catch (error) {
      console.error("An error occurred during mobile verification:", error);
    } finally {
      setLoading(false);
    }
  };

  const isVerifiedPhone = getCheckCICookie() && myInfo && !myInfo?.has_verified_phone;
  const isChicruitingVerifiedPhone = myInfo && !myInfo?.has_verified_phone && isChicruiting;

  if (isVerifiedPhone || isChicruitingVerifiedPhone)
    return (
      <PageWrapper widthType="narrow">
        <article className="lg:h-[calc(100vh-250px)] flex flex-col pt-10 lg:pt-0 gap-5 justify-center items-center">
          <h1 onClick={() => console.log(mobileVerifiedMeta)} className="text-xl font-semibold">
            2차 본인인증을 완료해주세요.
          </h1>
          <div className="text-center pb-5">
            치과의사만의 커뮤니티를 유지하기 위한
            <br className="lg:hidden" /> 재 인증 절차를 실시 중입니다.
            <br />
            주기적인 인증 절차를 통해 더 안전한 치과의사만의
            <br className="lg:hidden" /> 커뮤니티를 조성하기 위함이니, 양해 부탁드립니다.
          </div>
          <StyledButton
            onClick={() => mobileVerifyAndFetchUserData(setLoading)}
            className="w-full"
            size="large"
            disabled={loading}
          >
            {loading ? "Loading..." : "본인 인증하기"}
          </StyledButton>
          <StyledButton onClick={() => navigate("/logout")} color="transparent" size="medium">
            로그아웃
          </StyledButton>
        </article>
        <ChannelTalk />
      </PageWrapper>
    );

  return <Outlet />;
};

export default CheckCI;
